import React, { ReactElement } from "react";
import { FaChevronRight } from "react-icons/fa";

const ForwardIcon = (): ReactElement => (
    <FaChevronRight size="16" />
);

export default ForwardIcon;
